module.exports = __webpack_public_path__ + "img/rempah.688c17cf.png";